import { render } from "./ReportIncident.vue?vue&type=template&id=280b9290"
import script from "./ReportIncident.vue?vue&type=script&lang=js"
export * from "./ReportIncident.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__